import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const DONUT_THUMB = "/donuts/donut_play.png?v=5";
const VIDEO_SRC =
  "https://customer-assets.emergentagent.com/job_bobo-donuts-hub/artifacts/l6e57tul_4DAC371E-352A-43E1-9EF4-492A23904B6E.mov";

export const WatchStoryDonut = ({ caption = "Watch our story", sizeClass = "w-[200px] sm:w-[226px]" }) => {
  const [open, setOpen] = useState(false);

  return (
    <div data-testid="about-watch-story" className="flex flex-col items-center">
      <button
        data-testid="about-watch-story-btn"
        onClick={() => setOpen(true)}
        aria-label="Watch our story"
        className="group relative focus:outline-none"
      >
        <motion.div
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
          className={`relative ${sizeClass}`}
        >
          <img
            src={DONUT_THUMB}
            alt="Watch our story"
            className="w-full h-auto select-none drop-shadow-[0_7px_6px_rgba(17,17,17,0.28)] transition-transform duration-300 group-hover:scale-105 group-hover:-rotate-3"
          />
          <span
            className="absolute grid place-items-center w-[16%] h-[16%] transition-transform duration-300 group-hover:scale-125"
            style={{ left: "45%", top: "49%", transform: "translate(-50%, -50%)" }}
          >
            <Play className="w-full h-full text-[#ff648b] fill-[#ff648b]" />
          </span>
        </motion.div>
      </button>
      <p
        data-testid="about-watch-story-caption"
        className="mt-4 font-display font-semibold text-[#111111] text-xl"
      >
        {caption}
      </p>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          data-testid="about-story-video-dialog"
          className="max-w-3xl p-2 bg-black border-none"
        >
          <DialogTitle className="sr-only">Bobo's Donuts story video</DialogTitle>
          <div className="relative w-full aspect-video">
            <video
              data-testid="about-story-video"
              src={VIDEO_SRC}
              controls
              autoPlay
              playsInline
              className="absolute inset-0 w-full h-full object-contain rounded-lg"
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
